// import React from "react";
// import { Box, Container, Grid, Typography, Chip } from "@mui/material";
// import AnimatedSection from "../common/AnimatedSection";
// import SectionHeading from "../common/SectionHeading";

// const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7";

// /* Animated classroom SVG */
// const ClassroomSVG = () => (
//   <svg viewBox="0 0 360 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 360, height: "auto" }}>
//     {/* Background */}
//     <rect width="360" height="280" rx="16" fill="#1B1F3B"/>
//     {/* Chalkboard */}
//     <rect x="40" y="30" width="280" height="140" rx="8" fill="#2A5F3B" stroke={TEAL} strokeWidth="3"/>
//     {/* Math on board */}
//     <text x="60" y="75" fontFamily="Space Grotesk, sans-serif" fontSize="16" fill={YELLOW} fontWeight="bold" style={{ animation: "blink 3s ease-in-out infinite" }}>2 + 3 = 5 ✓</text>
//     <text x="60" y="105" fontFamily="Space Grotesk, sans-serif" fontSize="13" fill="#fff" opacity="0.8">A² + B² = C²</text>
//     <text x="60" y="135" fontFamily="Space Grotesk, sans-serif" fontSize="12" fill={CORAL} opacity="0.9">Hello World! 🌏</text>
//     {/* Stars on board */}
//     <text x="260" y="65" fontSize="18" style={{ animation: "starSpin 3s linear infinite" }}>⭐</text>
//     {/* Teacher */}
//     <g style={{ animation: "wiggle 4s ease-in-out infinite", transformOrigin: "310px 200px" }}>
//       <circle cx="310" cy="185" r="18" fill="#FDBCB4" stroke={NAVY} strokeWidth="1.5"/>
//       <rect x="298" y="200" width="24" height="30" rx="6" fill={CORAL} stroke={NAVY} strokeWidth="1.5"/>
//       {/* Pointer */}
//       <rect x="288" y="195" width="36" height="4" rx="2" fill={YELLOW} stroke={NAVY} strokeWidth="1"/>
//     </g>
//     {/* Students (desks) */}
//     {[[60,220],[130,220],[200,220],[60,260],[130,260]].map(([x,y],i)=>(
//       <g key={i} style={{ animation: `bounce ${2+i*0.3}s ease-in-out infinite ${i*0.2}s`, transformOrigin: `${x}px ${y}px` }}>
//         <rect x={x-18} y={y-10} width="36" height="22" rx="5" fill={YELLOW} stroke={NAVY} strokeWidth="1.5"/>
//         <circle cx={x} cy={y-22} r="12" fill="#FDBCB4" stroke={NAVY} strokeWidth="1.5"/>
//         <ellipse cx={x} cy={y-30} rx="11" ry="6" fill={[NAVY,CORAL,TEAL,PURPLE,"#FF9F1C"][i]}/>
//       </g>
//     ))}
//     {/* Decorative atoms/planets */}
//     <circle cx="30" cy="60" r="12" fill="none" stroke={TEAL} strokeWidth="2" strokeDasharray="4 3" style={{ animation: "rotateSlow 5s linear infinite" }}/>
//     <circle cx="30" cy="60" r="4" fill={TEAL}/>
//   </svg>
// );

// const CARD_COLORS = [CORAL, TEAL, PURPLE];

// const AcademicsSection = ({ cards }) => (
//   <AnimatedSection id="academics" sx={{ backgroundColor: NAVY, py: { xs: 9, md: 12 } }}>
//     <Container maxWidth="xl">
//       <SectionHeading
//         eyebrow="Academics"
//         title="Learning That Sparks Curiosity 🧠"
//         description="Three pillars of academic excellence that keep every student engaged, growing and future-ready."
//         align="center"
//         dark
//         eyebrowColor={YELLOW}
//         eyebrowBg="rgba(255,211,61,0.15)"
//       />

//       <Grid container spacing={3} alignItems="stretch">
//         {/* Left: animated SVG */}
//         <Grid item xs={12} md={5} sx={{ display: "flex", alignItems: "center" }}>
//           <Box sx={{ width: "100%", borderRadius: "20px", border: `3px solid ${TEAL}`, boxShadow: `6px 6px 0 ${TEAL}`, overflow: "hidden" }}>
//             <ClassroomSVG />
//           </Box>
//         </Grid>

//         {/* Right: cards */}
//         <Grid item xs={12} md={7}>
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 3, height: "100%" }}>
//             {cards.map((card, i) => (
//               <Box
//                 key={i}
//                 sx={{
//                   p: 3,
//                   borderRadius: "16px",
//                   backgroundColor: "rgba(255,255,255,0.05)",
//                   border: `2.5px solid ${CARD_COLORS[i]}`,
//                   boxShadow: `5px 5px 0 ${CARD_COLORS[i]}`,
//                   transition: "all 0.2s ease",
//                   "&:hover": { transform: "translate(-2px,-2px)", boxShadow: `7px 7px 0 ${CARD_COLORS[i]}`, backgroundColor: "rgba(255,255,255,0.08)" },
//                 }}
//               >
//                 <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.3rem", color: CARD_COLORS[i], mb: 1 }}>
//                   {["📐", "🖥️", "💻"][i]} {card.title}
//                 </Typography>
//                 <Typography sx={{ color: "rgba(255,248,240,0.75)", fontWeight: 600, lineHeight: 1.8, fontSize: "0.93rem", mb: 2 }}>
//                   {card.description}
//                 </Typography>
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                   {card.tags.map((tag) => (
//                     <Chip key={tag} label={tag} size="small"
//                       sx={{ backgroundColor: `${CARD_COLORS[i]}22`, color: CARD_COLORS[i], border: `1.5px solid ${CARD_COLORS[i]}`, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "0.72rem" }}
//                     />
//                   ))}
//                 </Box>
//               </Box>
//             ))}
//           </Box>
//         </Grid>
//       </Grid>
//     </Container>
//   </AnimatedSection>
// );

// export default AcademicsSection;












import React from "react";
import { Box, Container, Grid, Typography, Chip } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B";
const CORAL = "#FF6B6B";
const YELLOW = "#FFD93D";
const TEAL = "#06D6A0";
const PURPLE = "#845EF7";
const CREAM = "#FFF8F0";
const ORANGE = "#FF9F1C";
const PINK = "#FF85A2";

/* Animated classroom SVG - Light and playful */
const ClassroomSVG = () => (
  <svg viewBox="0 0 360 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 360, height: "auto" }}>
    {/* Background - Warm and inviting */}
    <rect width="360" height="280" rx="16" fill="#FFF0E0" stroke={NAVY} strokeWidth="3" />

    {/* Chalkboard */}
    <rect x="40" y="30" width="280" height="140" rx="8" fill="#2D5A27" stroke={NAVY} strokeWidth="3" />
    <rect x="36" y="26" width="280" height="140" rx="8" fill="none" stroke={NAVY} strokeWidth="3" />

    {/* Chalk drawings on board */}
    <text x="60" y="70" fontFamily="Space Grotesk, sans-serif" fontSize="18" fill={YELLOW} fontWeight="bold" style={{ animation: "blink 3s ease-in-out infinite" }}>
      2 + 3 = 5 ⭐
    </text>
    <text x="60" y="100" fontFamily="Space Grotesk, sans-serif" fontSize="14" fill="#E8F4E6" opacity="0.9">
      A² + B² = C²
    </text>
    <text x="60" y="130" fontFamily="Space Grotesk, sans-serif" fontSize="13" fill={CORAL} opacity="0.95">
      Hello World! 🌍
    </text>

    {/* Drawings on board */}
    <circle cx="270" cy="65" r="12" stroke={YELLOW} strokeWidth="2" fill="none" style={{ animation: "rotateSlow 5s linear infinite" }} />
    <circle cx="270" cy="65" r="3" fill={YELLOW} />

    {/* Decorative elements */}
    <text x="250" y="155" fontSize="20" style={{ animation: "starSpin 3s linear infinite" }}>✨</text>
    <text x="280" y="150" fontSize="16" style={{ animation: "starSpin 4s linear infinite reverse" }}>🌟</text>

    {/* Teacher */}
    <g style={{ animation: "wiggle 3s ease-in-out infinite", transformOrigin: "310px 195px" }}>
      <circle cx="310" cy="180" r="18" fill="#FDBCB4" stroke={NAVY} strokeWidth="2" />
      <ellipse cx="310" cy="168" rx="16" ry="8" fill={NAVY} />
      {/* Eyes & smile */}
      <circle cx="303" cy="182" r="3" fill={NAVY} />
      <circle cx="317" cy="182" r="3" fill={NAVY} />
      <path d="M303 190 Q310 195 317 190" stroke={NAVY} strokeWidth="2" strokeLinecap="round" fill="none" />
      <rect x="296" y="196" width="28" height="32" rx="8" fill={CORAL} stroke={NAVY} strokeWidth="2" />
      {/* Pointer stick */}
      <rect x="284" y="190" width="42" height="4" rx="2" fill={YELLOW} stroke={NAVY} strokeWidth="1.5" />
    </g>

    {/* Students at desks */}
    {[[70, 215], [140, 215], [210, 215], [70, 255], [140, 255]].map(([x, y], i) => (
      <g key={i} style={{ animation: `bounce ${2.5 + i * 0.3}s ease-in-out infinite`, transformOrigin: `${x}px ${y}px` }}>
        {/* Desk */}
        <rect x={x - 20} y={y - 12} width="40" height="24" rx="6" fill={[YELLOW, TEAL, CORAL, PURPLE, ORANGE][i]} stroke={NAVY} strokeWidth="2" />
        <rect x={x - 20} y={y - 12} width="40" height="4" rx="2" fill={NAVY} opacity="0.15" />
        {/* Student */}
        <circle cx={x} cy={y - 24} r="14" fill="#FDBCB4" stroke={NAVY} strokeWidth="2" />
        <ellipse cx={x} cy={y - 32} rx="13" ry="7" fill={[NAVY, PURPLE, CORAL, TEAL, ORANGE][i]} />
        {/* Tiny book on desk */}
        <rect x={x - 10} y={y - 16} width="20" height="8" rx="3" fill="#fff" stroke={NAVY} strokeWidth="1.5" />
      </g>
    ))}

    {/* Floating letters */}
    {["A", "B", "C", "D"].map((l, i) => (
      <text key={l} x={15 + i * 28} y={30 + i * 15} fontFamily="Fredoka One, cursive" fontSize="20" fill={[CORAL, TEAL, YELLOW, PURPLE][i]} style={{ animation: `floatY ${2 + i * 0.4}s ease-in-out infinite` }} stroke={NAVY} strokeWidth="1">
        {l}
      </text>
    ))}
  </svg>
);

const CARD_COLORS = [TEAL, CORAL, PURPLE];
const CARD_ICONS = ["📐", "🖥️", "💻"];
const CARD_EMOJIS = ["📚", "🔬", "🎯"];

const AcademicsSection = ({ cards }) => (
  <AnimatedSection id="academics" sx={{ backgroundColor: CREAM, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
    {/* Decorative background elements */}
    <Box sx={{ position: "absolute", top: -40, right: -40, width: 200, height: 200, borderRadius: "50%", backgroundColor: TEAL, border: `3px solid ${NAVY}`, opacity: 0.1 }} />
    <Box sx={{ position: "absolute", bottom: -30, left: -30, width: 150, height: 150, borderRadius: "50%", backgroundColor: CORAL, border: `3px solid ${NAVY}`, opacity: 0.1 }} />
    <Box sx={{ position: "absolute", top: "50%", left: "10%", fontSize: "40px", opacity: 0.08, animation: "floatY 4s ease-in-out infinite" }}>📖</Box>
    <Box sx={{ position: "absolute", bottom: "20%", right: "8%", fontSize: "35px", opacity: 0.08, animation: "floatY 3.5s ease-in-out infinite" }}>✏️</Box>

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <SectionHeading
        eyebrow="Academics"
        title="Inspiring Learning for a Brighter Future 🧠"
        description="Our academic approach encourages students to learn with curiosity, think creatively, and build the knowledge and skills they need to succeed in the future."
        align="center"
        eyebrowColor={CORAL}
        eyebrowBg="#FFE8E8"
      />

      <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
        {/* Left: animated SVG */}
        <Grid item xs={12} md={5}>
          <Box sx={{ position: "relative" }}>
            <Box sx={{
              position: "absolute", top: -16, left: -16, width: "100%", height: "100%",
              borderRadius: "24px", border: `4px solid ${NAVY}`, backgroundColor: YELLOW, zIndex: 0
            }} />
            <Box sx={{ position: "relative", zIndex: 1, borderRadius: "20px", border: `3px solid ${NAVY}`, overflow: "hidden", boxShadow: `5px 5px 0 ${NAVY}` }}>
              <ClassroomSVG />
            </Box>
          </Box>
        </Grid>

        {/* Right: cards */}
        <Grid item xs={12} md={7}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {cards.map((card, i) => (
              <Box
                key={i}
                sx={{
                  p: 3.5,
                  borderRadius: "16px",
                  backgroundColor: "#fff",
                  border: `2.5px solid ${NAVY}`,
                  boxShadow: `5px 5px 0 ${CARD_COLORS[i]}`,
                  transition: "all 0.2s ease",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    transform: "translate(-3px,-3px)",
                    boxShadow: `8px 8px 0 ${CARD_COLORS[i]}`,
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "4px",
                    height: "100%",
                    backgroundColor: CARD_COLORS[i],
                    borderRadius: "4px 0 0 4px",
                  }
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                  <Box sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "12px",
                    backgroundColor: CARD_COLORS[i],
                    border: `2px solid ${NAVY}`,
                    display: "grid",
                    placeItems: "center",
                    fontSize: "1.4rem",
                    boxShadow: `3px 3px 0 ${NAVY}`,
                    animation: `wiggle ${3 + i * 0.4}s ease-in-out infinite`,
                  }}>
                    {CARD_ICONS[i]}
                  </Box>
                  <Box>
                    <Typography sx={{
                      fontFamily: "'Fredoka One', cursive",
                      fontSize: "1.3rem",
                      color: NAVY,
                      lineHeight: 1.2,
                    }}>
                      {card.title}
                    </Typography>
                    <Typography sx={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      color: CARD_COLORS[i],
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}>
                      {["Core Program", "Digital Skills", "Tech Lab"][i]}
                    </Typography>
                  </Box>
                </Box>

                <Typography sx={{
                  color: "#4A4E6D",
                  fontWeight: 600,
                  lineHeight: 1.8,
                  fontSize: "0.93rem",
                  mb: 2.5,
                  pl: 0.5,
                }}>
                  {CARD_EMOJIS[i]} {card.description}
                </Typography>

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {card.tags.map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      sx={{
                        backgroundColor: `${CARD_COLORS[i]}15`,
                        color: NAVY,
                        border: `1.5px solid ${CARD_COLORS[i]}`,
                        fontFamily: "'Space Grotesk', sans-serif",
                        fontWeight: 800,
                        fontSize: "0.72rem",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: `${CARD_COLORS[i]}30`,
                          transform: "translateY(-1px)",
                        },
                        transition: "all 0.2s ease",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Container>
  </AnimatedSection>
);

export default AcademicsSection;